export const SADE_SATI_HI_HEADLINE = "साढ़े साती का लाइव चरण जाँचें";
export const SADE_SATI_PAGE_HEADLINE =
  "Sade Sati: Why These 7.5 Years Feel So Heavy — Check Your Phase & Upay";
